import React from "react";
import { Image } from "../../../../client/api";
import EmblemImage from "../../EmblemImage";

const Field: React.FC<{ team1: Image; team2: Image; onClickTeam1?: () => void; onClickTeam2?: () => void }> = ({ team1, team2, onClickTeam1, onClickTeam2 }) => (
  <div className="relative w-full mx-auto">
    <div className="relative w-full aspect-[345/618] rounded-xl overflow-hidden">
      <div className="absolute inset-0 opacity-60">
        <div className="absolute inset-x-0 top-0 h-1/2">
          <svg className="w-full h-full rotate-180" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <clipPath id="clipTop">
                <path d="M0 0 H1000 V960 A40 40 0 0 1 960 1000 H40 A40 40 0 0 1 0 960 Z" />
              </clipPath>
            </defs>
            <g clipPath="url(#clipTop)">
            <rect x="0" y="0" width="1000" height="1000" fill="#00AD5A" />
            <rect x="0" y="50" width="1000" height="100" fill="#00944D" />
            <rect x="0" y="250" width="1000" height="100" fill="#00944D" />
            <rect x="0" y="450" width="1000" height="100" fill="#00944D" />
            <rect x="0" y="650" width="1000" height="100" fill="#00944D" />
            <rect x="0" y="850" width="1000" height="100" fill="#00944D" />
            <line x1="20" y1="0" x2="980" y2="0" strokeWidth="3" stroke="#ffffff" vectorEffect="non-scaling-stroke" />
            <line x1="20" y1="970" x2="980" y2="970" strokeWidth="3" stroke="#ffffff" vectorEffect="non-scaling-stroke" />
            <line x1="20" y1="0" x2="20" y2="970" strokeWidth="3" stroke="#ffffff" vectorEffect="non-scaling-stroke" />
            <line x1="980" y1="0" x2="980" y2="970" strokeWidth="3" stroke="#ffffff" vectorEffect="non-scaling-stroke" />
            <rect x="230" y="680" width="540" height="290" strokeWidth="2" stroke="#ffffff" fill="none" vectorEffect="non-scaling-stroke" />
            <rect x="340" y="840" width="320" height="130" strokeWidth="2" stroke="#ffffff" fill="none" vectorEffect="non-scaling-stroke" />
            <path d="M 350 0 A 75 75 0 0 0 650 0" stroke="white" strokeWidth="2" fill="none" vectorEffect="non-scaling-stroke" />
            <path d="M 650 680 A 55 38 0 0 0 350 680" stroke="white" strokeWidth="2" fill="none" vectorEffect="non-scaling-stroke" />
            </g>
          </svg>
        </div>
        <div className="absolute inset-x-0 bottom-0 h-1/2">
          <svg className="w-full h-full" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <clipPath id="clipBottom">
                <path d="M0 0 H1000 V960 A40 40 0 0 1 960 1000 H40 A40 40 0 0 1 0 960 Z" />
              </clipPath>
            </defs>
            <g clipPath="url(#clipBottom)">
            <rect x="0" y="0" width="1000" height="1000" fill="#00AD5A" />
            <rect x="0" y="50" width="1000" height="100" fill="#00944D" />
            <rect x="0" y="250" width="1000" height="100" fill="#00944D" />
            <rect x="0" y="450" width="1000" height="100" fill="#00944D" />
            <rect x="0" y="650" width="1000" height="100" fill="#00944D" />
            <rect x="0" y="850" width="1000" height="100" fill="#00944D" />
            <line x1="20" y1="0" x2="980" y2="0" strokeWidth="3" stroke="#ffffff" vectorEffect="non-scaling-stroke" />
            <line x1="20" y1="970" x2="980" y2="970" strokeWidth="3" stroke="#ffffff" vectorEffect="non-scaling-stroke" />
            <line x1="20" y1="0" x2="20" y2="970" strokeWidth="3" stroke="#ffffff" vectorEffect="non-scaling-stroke" />
            <line x1="980" y1="0" x2="980" y2="970" strokeWidth="3" stroke="#ffffff" vectorEffect="non-scaling-stroke" />
            <rect x="230" y="680" width="540" height="290" strokeWidth="2" stroke="#ffffff" fill="none" vectorEffect="non-scaling-stroke" />
            <rect x="340" y="840" width="320" height="130" strokeWidth="2" stroke="#ffffff" fill="none" vectorEffect="non-scaling-stroke" />
            <path d="M 350 0 A 75 75 0 0 0 650 0" stroke="white" strokeWidth="2" fill="none" vectorEffect="non-scaling-stroke" />
            <path d="M 650 680 A 55 38 0 0 0 350 680" stroke="white" strokeWidth="2" fill="none" vectorEffect="non-scaling-stroke" />
            </g>
    </svg>
        </div>
      </div>

      <div className="absolute left-14 top-8 w-16 h-16">
        <button type="button" onClick={onClickTeam1} className="w-16 h-16">
          <EmblemImage image={team1} width={64} />
        </button>
      </div>
      <div className="absolute left-14 bottom-8 w-16 h-16">
        <button type="button" onClick={onClickTeam2} className="w-16 h-16">
          <EmblemImage image={team2} width={64} />
        </button>
    </div>
    </div>
  </div>
);

export default Field;
